document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.image-with-text').forEach(initImageWithTextVideo);
});

function initImageWithTextVideo(sectionRoot) {
  if (!sectionRoot || window.__ultraShouldSuppressVideo === true) return;

  var video = sectionRoot.querySelector('.image-with-text__video');
  if (!video) return;

  video.muted = true;
  video.playsInline = true;
  video.preload = 'none';

  var isInView = false;

  function ensureVideoSources() {
    if (video.dataset.sourcesReady === 'true') return;

    var needsLoad = false;
    video.querySelectorAll('source').forEach(function (source) {
      var dataSrc = source.getAttribute('data-src');
      if (dataSrc && !source.getAttribute('src')) {
        source.setAttribute('src', dataSrc);
        needsLoad = true;
      }
    });

    if (needsLoad) {
      try {
        video.load();
      } catch (error) {}
    }

    video.dataset.sourcesReady = 'true';
  }

  function playVideo() {
    if (window.__ultraShouldSuppressVideo === true) return;
    ensureVideoSources();
    video.muted = true;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function pauseVideo() {
    video.pause();
  }

  function warmVideo() {
    if (window.__ultraShouldSuppressVideo === true) return;
    video.preload = 'auto';
    ensureVideoSources();
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          isInView = entry.isIntersecting && entry.intersectionRatio >= 0.2;
          if (isInView) {
            playVideo();
          } else {
            pauseVideo();
          }
        });
      },
      { rootMargin: '100px 0px', threshold: [0, 0.2, 0.5, 1] }
    );

    observer.observe(video);
  } else {
    playVideo();
  }

  function onPageLoad() {
    warmVideo();
    if (isInView) {
      playVideo();
    }
  }

  if (document.readyState === 'complete') {
    onPageLoad();
  } else {
    window.addEventListener('load', onPageLoad);
  }
}
